<template>
  <div class="oi-container">
    <div class="oi-wrapper">
      <div v-for="(items, index) in orders.order_info" :key="index" class="pic-title-price">
        <div v-for="(item, i) in items.menu" :key="i" class="pic-title-price-container">
          <div class="pic-title">
            <img class="meal-icon" :src="item.menu_photo ? item.menu_photo : '../../../static/img/user/pic_home_default.png'" @error="errorLoadImg()">
            <span class="meal-name-count">
              <span class="name">{{ item.menu_name }}</span>
              <span class="count">数量：{{ item.number }}</span>
            </span>
          </div>
          <div class="remark">{{ item.notice }}</div>
          <div class="price">总价：¥{{ item.dis_price }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailItem',
  props: {
    orders: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      isCancel: false
    }
  },
  computed: {
    commentText () {
      return this.orders.is_discuss === 1 ? '评价' : '已评价'
    },
    cancelText () {
      return this.isCancel ? '撤销订单中...' : '撤销订单'
    }
  },
  methods: {
    /**
     * 当订单未评价时，弹出评价弹窗
     */
    showOrderComment () {
      if (this.orders.is_discuss === 1) {
        this.$store.commit('set_comment_need_data', this.orders)
        this.$store.commit('toggle_show_order_comment')
      } else {
        this.$store.commit('show_alert', '该订单已经被评价了呦')
      }
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg () {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/user/pic_home_default.png"
    }
  }
}
</script>

<style lang="less" scoped>
.oi-container {
  width: 902px;
  display: flex;
  flex-direction: row;
	background-color: #ffffff;
  .oi-wrapper {
    display: flex;
    flex-direction: column;
    .pic-title-price {
      display: flex;
      flex-direction: column;
      border: solid 1px #e0e0e0;
      border-top: 0;
      .pic-title-price-container {
        // width: 739px;
        width: 100%;
        height: 134px;
        display: flex;
        .pic-title {
          width: 578px;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .meal-icon {
            width: 90px;
            height: 90px;
            margin-left: 20px;
            border-radius: 6px;
          }
          .meal-name-count {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            .name {
              font-size: 16px;
              color: #333333;
            }
            .count {
              font-size: 14px;
              color: #999999;
              margin-top: 15px;
            }
          }
        }
        .price, .remark {
          color: #333;
          width: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #e0e0e0;
        }
        .remark {
          color: #999;
          overflow: auto;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/order_detail_item.vue